var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletwhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H25",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0832 22.5H45.577C41.1163 22.5 37.5 25.8577 37.5 30C37.5 34.1423 41.1163 37.5 45.577 37.5H52.0832C52.2917 37.5 52.3957 37.5 52.4837 37.4948C53.832 37.4125 54.9057 36.4155 54.9942 35.1635C55 35.0818 55 34.985 55 34.7918V25.2082C55 25.015 55 24.9181 54.9942 24.8365C54.9057 23.5846 53.832 22.5874 52.4837 22.5054C52.3957 22.5 52.2917 22.5 52.0832 22.5Z",
    stroke: "white",
    strokeWidth: 3.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4125 22.5C52.2183 17.8192 51.5915 14.9494 49.571 12.9289C46.6422 10 41.928 10 32.5 10H25C15.5719 10 10.8579 10 7.92893 12.9289C5 15.8579 5 20.5719 5 30C5 39.428 5 44.1422 7.92893 47.071C10.8579 50 15.5719 50 25 50H32.5C41.928 50 46.6422 50 49.571 47.071C51.5915 45.0507 52.2183 42.1808 52.4125 37.5",
    stroke: "white",
    strokeWidth: 3.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9766 30H44.9991",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletwhiteIcon);
export default __webpack_public_path__ + "static/media/Walletwhite_icon.00cb4ab93468ffcc18205290b5fd17c3.svg";
export { ForwardRef as ReactComponent };